<template>
    <div class="block-history">
      <div class="head-block-history">
        <p>{{__('My Games Played')}}</p>
          <div class="wrap-btn">
              <div class="wrap-btn-sorting">
                  <v-btn text v-ripple="false" class="btn-search" @click="modal_sorting = !modal_sorting" :class="(modal_sorting || filter.length) ? 'btn-search--active': ''">
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27778 3.63981C6.27778 5.0963 5.0963 6.2787 3.63889 6.2787C2.18148 6.2787 1 5.0963 1 3.63981C1 2.18241 2.18148 1 3.63889 1C5.0963 1 6.27778 2.18241 6.27778 3.63981Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.93269 3.63984H16.2781" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0006 12.8666C11.0006 11.4091 12.182 10.2277 13.6394 10.2277C15.0969 10.2277 16.2783 11.4091 16.2783 12.8666C16.2783 14.324 15.0969 15.5054 13.6394 15.5054C12.182 15.5054 11.0006 14.324 11.0006 12.8666Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M7.34574 12.8666H1.00037" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </v-btn>
                  <div v-if="filter.length" class="block-count">{{filter.length}}</div>
              </div>

              <div class="search" slot="right">
                  <div class="search__icon">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.6857 14.0743L16.6191 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </div>
                  <div class="search__input">
                      <SearchDefault
                              style="width: 100%"
                              :placeholder="__('Search ...')"
                              class_search="games_search"
                              v-model="search_played"
                              v-on:keyup.enter="searchPlayed()"
                              @searching="searchPlayed()"
                      ></SearchDefault>
                  </div>
                  <div class="cancel-icon" @click="cancelSearch()">
                      <svg v-if="show" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.59548 4.00097L7.87669 0.719756C8.04111 0.555319 8.04111 0.288726 7.87669 0.124304C7.71225 -0.0401327 7.44564 -0.0401327 7.28122 0.124304L3.99999 3.40552L0.71878 0.124304C0.554343 -0.0401327 0.287749 -0.0401327 0.123328 0.124304C-0.0410937 0.288742 -0.0411093 0.555335 0.123328 0.719756L3.40454 4.00097L0.123328 7.28218C-0.0411093 7.44662 -0.0411093 7.71321 0.123328 7.87763C0.287765 8.04207 0.554358 8.04206 0.71878 7.87763L3.99999 4.59642L7.28119 7.87763C7.44563 8.04207 7.71223 8.04206 7.87666 7.87763C8.04108 7.7132 8.04108 7.4466 7.87666 7.28218L4.59548 4.00097Z" fill="#607EA7"/>
                      </svg>
                  </div>
              </div>
          </div>
      </div>
          <div v-if="games && games.data.length" class="body-block-history">
            <GamesHistoryItem v-for="(game, key) in games.data" :key="key" v-bind:item="game" v-bind:profile="profile"></GamesHistoryItem>
          </div>
          <div v-else class="block-zero">
              <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.37 3.84922C24.5543 1.39621 31.4417 1.39621 37.626 3.84922C40.9075 5.15322 43.8873 7.11516 46.382 9.61422C46.4748 9.70732 46.5851 9.78123 46.7065 9.83172C46.8279 9.88221 46.9581 9.90829 47.0895 9.90848C47.221 9.90867 47.3513 9.88295 47.4728 9.8328C47.5944 9.78266 47.7049 9.70906 47.798 9.61622C47.8911 9.52337 47.965 9.4131 48.0155 9.29169C48.066 9.17028 48.092 9.04012 48.0922 8.90863C48.0924 8.77714 48.0667 8.64691 48.0165 8.52536C47.9664 8.40381 47.8928 8.29332 47.8 8.20022C45.1147 5.51034 41.9076 3.39806 38.376 1.99322H38.371C31.7101 -0.648781 24.2919 -0.648781 17.631 1.99322C17.3866 2.09274 17.1914 2.28483 17.088 2.52762C16.9847 2.77041 16.9814 3.04423 17.0791 3.28939C17.1767 3.53454 17.3673 3.73117 17.6093 3.83641C17.8513 3.94165 18.1251 3.94697 18.371 3.85122L18.37 3.84922Z" fill="#DAE6F1"/>
                  <path d="M18.371 52.1507C11.9658 49.5969 6.83738 44.6032 4.11399 38.2682C1.39059 31.9333 1.29526 24.7759 3.84897 18.3707C3.94473 18.1248 3.9394 17.851 3.83416 17.609C3.72892 17.367 3.5323 17.1764 3.28714 17.0788C3.04198 16.9811 2.76817 16.9844 2.52538 17.0877C2.28258 17.1911 2.09049 17.3863 1.99097 17.6307C-0.759092 24.5284 -0.656507 32.2361 2.27616 39.0583C5.20883 45.8804 10.7314 51.2582 17.629 54.0087C17.751 54.0574 17.8814 54.0817 18.0127 54.08C18.1441 54.0784 18.2739 54.0509 18.3946 53.999C18.5153 53.9472 18.6247 53.8721 18.7163 53.778C18.808 53.6839 18.8803 53.5727 18.929 53.4507C18.9777 53.3287 19.002 53.1983 19.0003 53.0669C18.9987 52.9355 18.9712 52.8058 18.9193 52.6851C18.8675 52.5643 18.7924 52.455 18.6983 52.3633C18.6042 52.2716 18.493 52.1994 18.371 52.1507Z" fill="#DAE6F1"/>
                  <path d="M54 28.0007C54 28.2659 54.1053 28.5203 54.2929 28.7078C54.4804 28.8953 54.7348 29.0007 55 29.0007C55.2652 29.0007 55.5196 28.8953 55.7071 28.7078C55.8946 28.5203 56 28.2659 56 28.0007C56.0017 24.4489 55.3259 20.9293 54.009 17.6307C53.9095 17.3863 53.7174 17.1911 53.4746 17.0877C53.2318 16.9844 52.958 16.9811 52.7128 17.0788C52.4677 17.1764 52.271 17.367 52.1658 17.609C52.0606 17.851 52.0552 18.1248 52.151 18.3707C53.3741 21.4339 54.0017 24.7023 54 28.0007Z" fill="#DAE6F1"/>
                  <path d="M52 44.0001H34C32.5314 44.0022 31.0917 44.4082 29.8384 45.1736C28.5851 45.9391 27.5665 47.0346 26.894 48.3401C26.8692 48.267 26.8356 48.1972 26.794 48.1321C24.56 45.2381 23 36.9591 23 28.0001C22.9826 24.3965 23.2454 20.797 23.786 17.2341C26.5883 16.9221 29.4167 16.9221 32.219 17.2341C32.5648 19.4927 32.7922 21.7678 32.9 24.0501C32.9133 24.3153 33.0313 24.5644 33.2283 24.7426C33.3258 24.8308 33.4397 24.899 33.5635 24.9431C33.6874 24.9873 33.8187 25.0067 33.95 25.0001C34.0813 24.9936 34.2101 24.9612 34.3289 24.9049C34.4477 24.8486 34.5543 24.7694 34.6425 24.6719C34.7307 24.5744 34.7988 24.4605 34.843 24.3366C34.8872 24.2128 34.9066 24.0814 34.9 23.9501C34.795 21.8391 34.593 19.6431 34.287 17.5261C36.1321 17.8344 37.9464 18.3045 39.709 18.9311C40.4765 21.5549 40.9 24.2673 40.969 27.0001H27C26.7348 27.0001 26.4804 27.1055 26.2929 27.293C26.1054 27.4806 26 27.7349 26 28.0001V43.0001C26 43.2653 26.1054 43.5197 26.2929 43.7072C26.4804 43.8948 26.7348 44.0001 27 44.0001C27.2652 44.0001 27.5196 43.8948 27.7071 43.7072C27.8946 43.5197 28 43.2653 28 43.0001V29.0001H33V32.0001C33 32.2653 33.1054 32.5197 33.2929 32.7072C33.4804 32.8948 33.7348 33.0001 34 33.0001H43C43.2652 33.0001 43.5196 32.8948 43.7071 32.7072C43.8946 32.5197 44 32.2653 44 32.0001V29.0001H49V41.0001C49 41.2653 49.1054 41.5197 49.2929 41.7072C49.4804 41.8948 49.7348 42.0001 50 42.0001C50.2652 42.0001 50.5196 41.8948 50.7071 41.7072C50.8946 41.5197 51 41.2653 51 41.0001V28.0001C51.0012 23.5326 49.7012 19.1614 47.2589 15.4206C44.8166 11.6797 41.3377 8.73112 37.2472 6.93495C33.1566 5.13878 28.6315 4.5728 24.2246 5.30614C19.8176 6.03948 15.7197 8.0404 12.4313 11.0645C9.14282 14.0886 6.80629 18.0049 5.70707 22.3351C4.60785 26.6653 4.79352 31.2218 6.24141 35.4482C7.68929 39.6746 10.3367 43.3879 13.8603 46.1344C17.3838 48.8809 21.631 50.5418 26.083 50.9141C25.9178 52.0468 25.9994 53.2018 26.3222 54.2999C26.6451 55.3981 27.2016 56.4135 27.9535 57.2765C28.7055 58.1395 29.6352 58.8297 30.6788 59.2998C31.7224 59.7699 32.8554 60.0088 34 60.0001C35.4021 59.9946 36.7783 59.6225 37.9922 58.9208C39.2061 58.2192 40.2154 57.2123 40.92 56.0001H42C42.2652 56.0001 42.5196 55.8948 42.7071 55.7072C42.8946 55.5197 43 55.2653 43 55.0001C43 54.7349 42.8946 54.4806 42.7071 54.293C42.5196 54.1055 42.2652 54.0001 42 54.0001H40.317C40.1285 54.0007 39.944 54.0545 39.7848 54.1553C39.6255 54.2562 39.498 54.4 39.417 54.5701C38.957 55.5406 38.2449 56.3699 37.355 56.9713C36.4652 57.5727 35.4302 57.9242 34.3582 57.9891C33.2861 58.0541 32.2163 57.8301 31.2603 57.3405C30.3044 56.851 29.4974 56.1138 28.9235 55.2059C28.3497 54.2981 28.03 53.2528 27.998 52.1793C27.9659 51.1057 28.2226 50.0433 28.7412 49.1028C29.2598 48.1623 30.0214 47.3782 30.9464 46.8325C31.8714 46.2867 32.926 45.9993 34 46.0001H52C53.0741 45.9987 54.129 46.2857 55.0543 46.8312C55.9797 47.3766 56.7417 48.1604 57.2607 49.1008C57.7798 50.0412 58.0368 51.1037 58.0051 52.1774C57.9734 53.2511 57.654 54.2965 57.0803 55.2047C56.5066 56.1128 55.6996 56.8502 54.7437 57.34C53.7877 57.8298 52.7178 58.054 51.6456 57.9892C50.5734 57.9244 49.5383 57.5729 48.6483 56.9715C47.7583 56.37 47.0461 55.5407 46.586 54.5701C46.472 54.3305 46.2674 54.146 46.0173 54.0572C45.7672 53.9684 45.4921 53.9826 45.2525 54.0966C45.0129 54.2107 44.8284 54.4152 44.7396 54.6653C44.6508 54.9154 44.665 55.1905 44.779 55.4301C45.3929 56.7237 46.3428 57.8288 47.5294 58.6301C48.7161 59.4314 50.0961 59.8995 51.5253 59.9856C52.9546 60.0717 54.3808 59.7727 55.6551 59.1196C56.9293 58.4666 58.005 57.4835 58.7697 56.2729C59.5345 55.0624 59.9604 53.6688 60.0029 52.2376C60.0454 50.8063 59.7029 49.3899 59.0114 48.1361C58.3198 46.8824 57.3044 45.8372 56.0711 45.1097C54.8378 44.3822 53.4319 43.999 52 44.0001ZM24.468 48.1911C21.42 46.7981 18.825 43.6611 17.128 39.4791C18.7423 39.9547 20.3885 40.3146 22.054 40.5561C22.4673 43.2087 23.2812 45.7831 24.468 48.1911ZM21.712 38.4831C19.8707 38.1829 18.0596 37.7201 16.3 37.1001C15.5264 34.4668 15.0998 31.7438 15.031 29.0001H17C17.2652 29.0001 17.5196 28.8948 17.7071 28.7072C17.8946 28.5197 18 28.2653 18 28.0001C18 27.7349 17.8946 27.4806 17.7071 27.293C17.5196 27.1055 17.2652 27.0001 17 27.0001H15.031C15.1006 24.2672 15.5248 21.5548 16.293 18.9311C18.054 18.3071 19.8662 17.8387 21.709 17.5311C21.2277 20.9999 20.9908 24.4982 21 28.0001C20.988 31.5069 21.2259 35.0101 21.712 38.4831ZM7.1 27.0001C7.6 24.2251 10.17 21.7111 13.969 19.9001C13.4016 22.2264 13.0841 24.6065 13.022 27.0001H7.1ZM13.022 29.0001C13.0848 31.4071 13.4053 33.8004 13.978 36.1391C10.133 34.3091 7.594 31.7651 7.1 29.0001H13.022ZM24.465 7.81013C23.2774 10.2097 22.4646 12.7772 22.055 15.4231C20.3925 15.6618 18.7493 16.0194 17.138 16.4931C18.835 12.3261 21.425 9.20013 24.465 7.81013ZM28 15.0001C26.687 15.0001 25.405 15.0621 24.158 15.1761C25.207 10.0001 26.769 7.00013 28 7.00013C29.167 7.00013 30.784 9.80513 31.861 15.1781C30.607 15.0631 29.319 15.0001 28 15.0001ZM33.94 15.4221C33.5329 12.7831 32.7292 10.2208 31.556 7.82213C34.587 9.22213 37.169 12.3391 38.862 16.4961C37.2491 16.021 35.6042 15.6621 33.94 15.4221ZM42.04 19.8981C45.84 21.7111 48.405 24.2251 48.909 26.9981H42.983C42.9207 24.6052 42.6033 22.2257 42.036 19.9001L42.04 19.8981ZM42 31.0001H35V29.0001H42V31.0001ZM47.93 21.4241C46.0071 19.6301 43.7465 18.2364 41.28 17.3241C40.2313 14.0565 38.443 11.0748 36.054 8.61113C38.834 9.77452 41.3323 11.5201 43.3809 13.7303C45.4295 15.9405 46.9807 18.564 47.93 21.4241ZM19.946 8.61213C17.557 11.0758 15.7687 14.0575 14.72 17.3251C12.2534 18.2374 9.99295 19.6311 8.07 21.4251C9.01935 18.565 10.5705 15.9415 12.6191 13.7313C14.6677 11.5211 17.1661 9.77553 19.946 8.61213ZM8.046 34.5121C9.97055 36.3158 12.2349 37.7184 14.707 38.6381C15.7549 41.9213 17.5483 44.9175 19.947 47.3921C17.1549 46.2243 14.6468 44.4692 12.5931 42.2461C10.5395 40.023 8.98829 37.3839 8.045 34.5081L8.046 34.5121Z" fill="#DAE6F1"/>
                  <path d="M34 55.5C34.2652 55.5 34.5196 55.3946 34.7071 55.2071C34.8946 55.0196 35 54.7652 35 54.5V53H36.5C36.7652 53 37.0196 52.8946 37.2071 52.7071C37.3946 52.5196 37.5 52.2652 37.5 52C37.5 51.7348 37.3946 51.4804 37.2071 51.2929C37.0196 51.1054 36.7652 51 36.5 51H35V49.5C35 49.2348 34.8946 48.9804 34.7071 48.7929C34.5196 48.6054 34.2652 48.5 34 48.5C33.7348 48.5 33.4804 48.6054 33.2929 48.7929C33.1054 48.9804 33 49.2348 33 49.5V51H31.5C31.2348 51 30.9804 51.1054 30.7929 51.2929C30.6054 51.4804 30.5 51.7348 30.5 52C30.5 52.2652 30.6054 52.5196 30.7929 52.7071C30.9804 52.8946 31.2348 53 31.5 53H33V54.5C33 54.7652 33.1054 55.0196 33.2929 55.2071C33.4804 55.3946 33.7348 55.5 34 55.5Z" fill="#DAE6F1"/>
                  <path d="M52 50C52.5523 50 53 49.5523 53 49C53 48.4477 52.5523 48 52 48C51.4477 48 51 48.4477 51 49C51 49.5523 51.4477 50 52 50Z" fill="#DAE6F1"/>
                  <path d="M52 55C52.5523 55 53 54.5523 53 54C53 53.4477 52.5523 53 52 53C51.4477 53 51 53.4477 51 54C51 54.5523 51.4477 55 52 55Z" fill="#DAE6F1"/>
                  <path d="M49.5 52.5C50.0523 52.5 50.5 52.0523 50.5 51.5C50.5 50.9477 50.0523 50.5 49.5 50.5C48.9477 50.5 48.5 50.9477 48.5 51.5C48.5 52.0523 48.9477 52.5 49.5 52.5Z" fill="#DAE6F1"/>
                  <path d="M54.5 52.5C55.0523 52.5 55.5 52.0523 55.5 51.5C55.5 50.9477 55.0523 50.5 54.5 50.5C53.9477 50.5 53.5 50.9477 53.5 51.5C53.5 52.0523 53.9477 52.5 54.5 52.5Z" fill="#DAE6F1"/>
                  <path d="M7 11C7.59334 11 8.17336 10.8241 8.66671 10.4944C9.16005 10.1648 9.54457 9.69623 9.77163 9.14805C9.9987 8.59987 10.0581 7.99667 9.94235 7.41473C9.8266 6.83279 9.54087 6.29824 9.12132 5.87868C8.70176 5.45912 8.16721 5.1734 7.58527 5.05765C7.00333 4.94189 6.40013 5.0013 5.85195 5.22836C5.30377 5.45543 4.83523 5.83994 4.50559 6.33329C4.17595 6.82664 4 7.40666 4 8C4 8.79565 4.31607 9.55871 4.87868 10.1213C5.44129 10.6839 6.20435 11 7 11ZM7 7C7.19778 7 7.39112 7.05865 7.55557 7.16853C7.72002 7.27841 7.84819 7.43459 7.92388 7.61732C7.99956 7.80004 8.01937 8.00111 7.98078 8.19509C7.9422 8.38907 7.84696 8.56726 7.7071 8.70711C7.56725 8.84696 7.38907 8.9422 7.19509 8.98079C7.00111 9.01937 6.80004 8.99957 6.61731 8.92388C6.43459 8.84819 6.27841 8.72002 6.16853 8.55557C6.05865 8.39112 6 8.19778 6 8C6 7.73478 6.10536 7.48043 6.29289 7.29289C6.48043 7.10536 6.73478 7 7 7Z" fill="#DAE6F1"/>
                  <path d="M31 39C30.7348 39 30.4804 39.1054 30.2929 39.2929C30.1054 39.4804 30 39.7348 30 40C30 40.2652 30.1054 40.5196 30.2929 40.7071C30.4804 40.8946 30.7348 41 31 41H46C46.2652 41 46.5196 40.8946 46.7071 40.7071C46.8946 40.5196 47 40.2652 47 40V36C47 35.7348 46.8946 35.4804 46.7071 35.2929C46.5196 35.1054 46.2652 35 46 35H31C30.7348 35 30.4804 35.1054 30.2929 35.2929C30.1054 35.4804 30 35.7348 30 36C30 36.2652 30.1054 36.5196 30.2929 36.7071C30.4804 36.8946 30.7348 37 31 37H45V39H31Z" fill="#DAE6F1"/>
              </svg>
              <p>{{__('You have not played games yet!')}}</p>

              <div class="wrap-btn">
                  <BaseButton :to="{name: 'games', params: {lang: $store.getters.getLang}}">
                      <span>{{__('Let’s Play')}}</span>
                  </BaseButton>
              </div>
          </div>
        <ProfileSorting v-if="modal_sorting" :modal_sorting.sync="modal_sorting" :sorting.sync="sorting" @sortingPlayed="sortingPlayed"  :search.sync="search" :filter.sync="filter"></ProfileSorting>
    </div>
</template>

<script>
    import GamesHistoryItem from './GamesHistoryItem';
    import SearchDefault from "../modules/SearchDefault.vue";
    import ProfileSorting from "../pages/Profile/ProfileSorting";

    export default {
        data () {
            return {
                games_history: null,
                loadingPage: false,
                show: false,
                modal_sorting: false,
                filter: [],
                search_played: null,
            }
        },
        props: {
            profile: {
                type: Object,
            },
            scroll: {
                type: Boolean,
            },
            games: {
                type: Object,
            },
            search: {
                type: String,
            },
            sorting: {
                type: Object
            }
        },
        watch: {
            search(val) {
                if(val) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            }
        },
        created() {
            // this.$addListener(window,'scroll', () => {
                // if (document.documentElement.scrollTop > 60) {
                //     this.$emit("update:scroll", true);
                // } else {
                //     this.$emit("update:scroll", false);
                // }

                // this.scrollHistory();
            // });
        },
        methods: {
            // scrollHistory: function () {
            //     const progress =
            //         document.documentElement.scrollTop /
            //         (document.documentElement.scrollHeight -
            //             document.documentElement.clientHeight);
            //     if (!this.loadingPage && this.next_page_url) {
            //         let bottomOfWindow = 0.7 <= progress;
            //         if (bottomOfWindow) {
            //             this.loadingPage = true;
            //             this.$http.get(this.next_page_url)
            //                 .then((response) => {
            //                     return response.json();
            //                 })
            //                 .then((response) => {
            //                     response = response.data;
            //                     let games = this.games.data;
            //                     this.games.data = games.concat(response.data);
            //                     this.next_page_url = response.next_page_url;
            //                     this.loadingPage = false;
            //                 })
            //                 .catch((err) => {
            //                     this.httpHandler(err);
            //                 });
            //         }
            //     }
            // },

            sortingPlayed(val) {
                this.$emit('update:sorting', val);
                this.$emit('sortingPlayed');
            },
            searchPlayed() {
                this.$emit('update:search', this.search_played);
                this.$emit('sortingPlayed');
            },
            cancelSearch() {
                this.search_played = null;
                this.$emit('update:search', this.search_played);
                this.$emit('sortingPlayed');
            }
        },
        components: {
            GamesHistoryItem,
            // ScrollPagination,
            SearchDefault,
            ProfileSorting
        }
    };
</script>

<style lang="scss" scoped>

    .block-history {
        /*overflow: hidden;*/
        /*min-height: calc(100vh - 475px);*/
        margin-bottom: 15px;
    }

    .head-block-history {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border-radius: 8px 8px 0 0;
        height: 63px;
        padding: 0 20px;
        border-bottom: 1px solid #F0F6FE;

        .wrap-btn {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .search {
                display: flex;
                align-items: center;
                padding-left: 20px;
                margin-left: 20px;
                border-left: 1px solid #E7F5FF;
                position: relative;

                &__icon {
                    /*margin-bottom: 3px;*/
                    svg  {
                        margin-right: 0;
                        color: #002b50;
                    }
                }

                .cancel-icon {
                    cursor: pointer;
                    position: absolute;
                    right: 10px;
                    top: 8px;

                    svg {
                        transition: .3s;
                        margin-right: 0;
                    }

                    &:hover {
                        svg {
                            transform: scale(1.15);
                            transition: .3s;
                        }
                    }
                }
            }
        }

        .wrap-btn-sorting {
            position: relative;
            .block-count {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                background: #26A9F4;
                border: 2px solid #FFFFFF;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                font-size: 12px;
                line-height: 16px;
                position: absolute;
                top: -7px;
                right: -7px;
            }
        }

        .v-btn.btn-search--active {
            background-color: #E7F5FF!important;
        }

        .v-btn.btn-search,
        .v-btn.btn-sorting {
            background: #fff;
            border-radius: 8px;
            transition: .3s;
            color: #002b50;

            &.v-btn:not(.v-btn--round).v-size--default {
                height: 40px;
                min-width: 40px;
                padding: 0;
            }

            &:hover {
                background-color: #E7F5FF;
                transition: .3s;
            }

            &.v-btn:before {
                background-color: #E7F5FF;
                transition: .3s;
            }

            svg {
                margin: 0;
            }

        }

        p {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: #002B50;
            margin-bottom: 0;

            span {
                font-size: 15px;
                line-height: 22px;
                color: #96AFD1;
                margin-left: 10px;
            }
        }

        a {
            font-size: 14px;
            line-height: 17px;
            color: #96AFD1;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
                color: #46BCFF;
            }
        }
        
    }

    .body-block-history {
        background-color: #fff;
        border-radius: 0 0 4px 4px;
    }

    .block-zero {
        background-color: #FFFFFF;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: #96AFD1;
        padding: 50px 0 70px;
        border-radius: 0 0 4px 4px;

        svg {
            margin-bottom: 20px;
        }

        p {
            margin-bottom: 20px;
        }

        .wrap-btn {
            display: flex;
            justify-content: center;
            margin: 0 auto;
        }
    }



    @media screen and (max-width: 1264px) {
      .block-history {
        padding: 0;
        margin: 0;
      }
    }

    @media screen and (max-width: 1250px) {
        .body-block-history {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }

    @media screen and (max-width: 740px) {
        .head-block-history {
            p {
                font-size: 16px;

                span {
                    font-size: 12px;
                    display: flex;
                    align-items: flex-start;

                    img {
                        height: 16px;
                    }
                }
            }

            a {
                font-size: 12px;
            }
        }
    }

    @media screen and (max-width: 600px) {
        .head-block-history {
            padding: 10px 15px;
            p {
                font-size: 14px;

                span {
                    font-size: 10px;
                    display: flex;
                    align-items: flex-start;

                    img {
                        height: 14px;
                    }
                }
            }

            a {
                font-size: 10px;
            }
        }
    }

    @media screen and (max-width: 500px) {
        .head-block-history {
            padding: 10px 15px;
            p {
                display: none;
            }
        }
    }

    @media screen and (max-width: 400px) {
        .head-block-history {
            padding: 10px 15px;
            p {
                font-size: 12px;

                span {
                    font-size: 10px;
                    display: flex;
                    align-items: flex-start;

                    img {
                        height: 14px;
                    }
                }
            }

            a {
                font-size: 8px;
            }
        }
    }

    .dark {
        .head-block-history {
            background-color: #222338;
            border-bottom: 2px solid #222338;

            p {
                color: #fff;
            }

            .v-btn.btn-search,
            .v-btn.btn-sorting {
                background: #171827;
                border: 1px solid #171827;
                color: #96AFD1;

                &:before {
                    /*background-color: #181818;*/
                    /*color: #26a9f4!important;*/
                }

                &:hover {
                    background-color: #0B0C1A;
                    /*color: #26a9f4!important;*/
                }
            }

            .search {
                border-left: 1px solid rgba(255, 255, 255, 0.1);
                &__icon {
                    svg {
                        color: #96AFD1;
                    }
                }

                .cancel-icon {
                    svg {
                        color: #96AFD1;
                    }
                }
            }
        }

        .body-block-history {
            background-color: #171827;


        }

        .block-item {
            border-bottom: 1px solid rgba(255, 255, 255, 0.07);
        }

        .block-zero {
            background: #171827;
        }
    }
   
</style>